import type { WidgetProps } from "@rjsf/core"
import { MultipleChoiceDropdown } from "dash-styled"

export function MultipleChoiceWidget({
    value = [],
    disabled,
    onChange
}: WidgetProps) {
    const handleAdd = (newValue: string) => {
        onChange([...value, newValue])
    }

    const handleChange = (index: number) => {
        const res = [...value]
        res.splice(index, 1)
        onChange(res)
    }

    return (
        <MultipleChoiceDropdown
            size="sm"
            addNewText="(new)"
            chipColor="blueviolet"
            chipClassname="pb-0.5"
            inputClassname="rounded-lg border-rhino-300"
            placeholder="Type here to add"
            choices={value}
            selectedIndices={Array.from(value.keys())}
            onClick={!disabled ? handleChange : undefined}
            onAdd={!disabled ? handleAdd : undefined}
        />
    )
}
